import { render, staticRenderFns } from "./releaseNeed.vue?vue&type=template&id=219c201e&scoped=true"
import script from "./releaseNeed.vue?vue&type=script&lang=js"
export * from "./releaseNeed.vue?vue&type=script&lang=js"
import style0 from "./releaseNeed.vue?vue&type=style&index=0&id=219c201e&prod&lang=css"
import style1 from "./releaseNeed.vue?vue&type=style&index=1&id=219c201e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219c201e",
  null
  
)

export default component.exports